import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCoEPt9VpjSEG6k2NWK7sIrP7itp3xyVuw",
  authDomain: "fir-chat-2-d380b.firebaseapp.com",
  projectId: "fir-chat-2-d380b",
  storageBucket: "fir-chat-2-d380b.appspot.com",
  messagingSenderId: "601213147353",
  appId: "1:601213147353:web:d615b022e266c3eeed06c8",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
